module.exports = __webpack_public_path__ + "img/03_DSC7672.323fca67.jpg";